import { render, staticRenderFns } from "./EventDashboard.vue?vue&type=template&id=43b3ab79&scoped=true&"
import script from "./EventDashboard.vue?vue&type=script&lang=js&"
export * from "./EventDashboard.vue?vue&type=script&lang=js&"
import style0 from "./EventDashboard.vue?vue&type=style&index=0&id=43b3ab79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b3ab79",
  null
  
)

export default component.exports